<template>

    <producto-form :idBusiness="idBusiness" :idProducto="idProducto" :idSectorParam="idSector" :filtro="filtro" :pag="pag"></producto-form>
</template>

<script>
    import ProductoForm from "../../../Widgets/Productos/ProductoForm";
    import swal from 'sweetalert2' 
    export default {
        components: {
            ProductoForm
        },
        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                pag: this.$route.params.pag,
                idSector: this.$route.params.idSector,
                idProducto: this.$route.params.idProducto,
                filtro: this.$route.params.filtro,
            }
        },
        created() {
            // console.log(this.idSector);
            let action = this.idProducto ?  this.$i18n.t("editar") :  this.$i18n.t("nuevo");
            this.$store.dispatch('setNameRoute', action  + ' ' + this.$i18n.t("producto"));

            this.getRestrictions();
        },
        methods: {

            getRestrictions() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness,
                        idRestriction: 12,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByTipo", config)
                    .then(function (response) {

                        if (!response.data.response) {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.$router.push({
                                name: 'configuracion'
                            })


                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            }


        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Productos/Producto.vue